import React from "react";
import Button from "@atlaskit/button/new";
import { Flex, Flex1 } from "../../../../../../../common/style";
import { ConditionType } from "../../../../../../../common/interfaces/flow/condition/ConditionType";
import DataConditionCell from "./DataConditionPanel";
import uuid from "react-uuid";
import HttpStatusConditionCell from "./HttpStatusConditionPanel";
import ConditionControl from "../controlbar/ConditionControl";
import DeleteIcon from "@atlaskit/icon/core/delete";

const CombinedConditionPanel = ({ combinedCondition, index, addCondition, removeCombinedCondition }) => {
  const renderCombinedCondition = () => {
    return combinedCondition.conditions.map((c, cindex) => {
      switch (c.type) {
        case ConditionType.DATA_CONDITION:
          return (
            <Flex key={uuid()}>
              <Flex1 key={uuid()}>
                <DataConditionCell key={uuid()} dataCondition={c} />
              </Flex1>
              <div key={uuid()} className="ihub-condition-delete-button">
                <Button iconAfter={DeleteIcon} onClick={() => onDelete(c, cindex)} key={uuid()}></Button>
              </div>
            </Flex>
          );
        case ConditionType.HTTP_STATUS_CODE_CONDITION:
          return (
            <Flex key={uuid()}>
              <Flex1 key={uuid()}>
                <HttpStatusConditionCell key={uuid()} httpCondition={c} />{" "}
              </Flex1>
              <div key={uuid()} className="ihub-condition-delete-button">
                <Button iconAfter={DeleteIcon} onClick={onDelete} key={uuid()}></Button>
              </div>
            </Flex>
          );
        default:
          break;
      }
    });
  };
  const onAddCondition = (conditions) => {
    combinedCondition.conditions = conditions;
    addCondition(combinedCondition, index);
  };
  const onDelete = (condition, cindex) => {
    combinedCondition.conditions.splice(cindex, 1);
    if (combinedCondition?.conditions?.length === 0) {
      removeCombinedCondition(index);
    } else {
      addCondition(combinedCondition, index);
    }
  };

  return (
    <>
      {index > 0 && (
        <>
          <hr />
          <center>OR run this action if...</center>
          <br />
        </>
      )}
      {renderCombinedCondition()}
      <br />
      <ConditionControl
        title="+ AND"
        conditions={combinedCondition.conditions}
        addCondition={onAddCondition}
        removeCombinedCondition={removeCombinedCondition}
        index={index}
      />
      <br />
    </>
  );
};

export default CombinedConditionPanel;
